module.exports = __webpack_public_path__ + "static/media/planing.88aeef3b.svg";